exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsible-panel__header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n}\n\n/* The title pushes the chevron to the right edge of the panel. */\n.collapsible-panel__header h2 {\n  margin: 0 auto 0 0;\n}\n\n.collapsible-panel__header__chevron {\n  margin-left: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.collapsible-panel__content {\n  margin-top: 2rem;\n}\n\n.collapsible-panel__content--collapsed {\n  display: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/collapsible-panel/collapsible-panel.component.css
// module id = ../../../../../src/app/shared/components/collapsible-panel/collapsible-panel.component.css
// module chunks = main